module.exports = __webpack_public_path__ + "static/img/not_found_record.62bc649.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/not_found_record.png
// module id = +2w5
// module chunks = 37